const tasks = [
  { id: '1', title: "breakfast meeting with department heads", done: true },
  { id: '2', title: "meet with team and brief them on any memos or directives", done: true },
  { id: '3', title: "work on Exodus Project - finalize samples and presentation template", done: false },
  { id: '4', title: "lunch at Zambino`s with Greg to discuss Exodus presentation", done: false },
  { id: '5', title: "meet with team to practice presentation", done: false },
];

export default tasks;
